module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '5mxw5grl',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
